import * as React from 'react';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';

import { EarlyAccessPaywallProvider as Provider } from '@/packages/EarlyAccessPaywall';
import { ESource } from '@/packages/EarlyAccessPaywall/shared/types/context';
import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';

import { fetchEarlyAccessPaywallMicrofrontend } from '../../services/fetchEarlyAccessPaywallMicrofrontend';

export const EarlyAccessPaywallProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => fetchEarlyAccessPaywallMicrofrontend(context), [context]);
  const { data: user } = useUserQuery();
  const isAuthenticated = !!user?.isAuthenticated;

  const params = {
    isAuthenticated,
    source: ESource.Listing,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
